import { render, staticRenderFns } from "./SearchService.vue?vue&type=template&id=415a092a"
import script from "./SearchService.vue?vue&type=script&lang=js"
export * from "./SearchService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports